export const SHOW_SHOP_MODAL = 'ui/SHOW_SHOP_MODAL'
